import { isPresetGradientColor } from '@flex-design-system/fx-colors';

function getGradientColorDataAttribute(color) {
  if (color === void 0 || !isPresetGradientColor(color)) {
    return;
  }
  return { ["data-gradient-color"]: "" };
}

export { getGradientColorDataAttribute };
//# sourceMappingURL=getGradientColorDataAttribute.mjs.map
